import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PlanCard from './partials/PlanCard';
const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};
export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};
const Container = styled.div`
  padding-top: 60px;
  width: 1140px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media only screen and ${device.tablet} {
    width: 345px;
    align-items: unset;
  }
`;
const TitleText = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 32px;
  text-align: center;
  vertical-align: middle;
  background-image: linear-gradient(90deg, #063257 0%, #006867 100%);
  color: transparent;
  background-clip: text;
  @media only screen and ${device.tablet} {
    font-size: 28px;
    width: 345px;
  }
`;

const CardListContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  width: 1140px;
  @media only screen and ${device.tablet} {
    width: 370px;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
    scrollbar-height: none;
    padding-left: 0px;
    padding-right: 45px;
  }
`;
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  padding-bottom: 60px;
  @media only screen and ${device.tablet} {
    align-items: unset;
  }
`;
const TitleContainer = styled.div`
  width: 100vw;
  justify-content: center;
  display: flex;
`;
const FindAPlanCards = (props) => {
  const planData = [
    {
      id: '0',
      planName: 'Standard',
      planDesc: 'For Individuals exploring analytics tools ​',
      plancost: 'Free (15-day trial)​',
      showSubscription: false,
      monthlySubscription: '100',
      yearlySubscription: '85',
      fundamentals: [
        '1 user login ​​',
        '2 channels​​',
        'Analyze Trending discussions (Up to 3 )​',
      ],
      includes: [
        'Platform Analytics​​',
        'Gender demographics analysis​',
        'Sentiment analysis​',
        'E-commerce sentiment analysis​​',
      ],
    },
    {
      id: '1',
      planName: 'Pro',
      planDesc: 'For freelancers and small businesses',
      plancost: '$5 trial (7 days)',
      showSubscription: true,
      monthlySubscription: '100',
      yearlySubscription: '85',
      fundamentals: [
        '3 user login​',
        'Up to 3 channels​',
        'Analyze Trending discussions (Up to 6 )​',
      ],
      includes: [
        'Sentiment insights​',
        'Emotional analysis',
        'GEN AI assistant',
        'Campaign analysis​',
        'Hashtag analysis​',
        'Influencer recognition​',
      ],
    },
    {
      id: '2',
      planName: 'Scale',
      planDesc: 'For start-ups and agencies​',
      plancost: '$10 trial (7 days)​',
      showSubscription: true,
      monthlySubscription: '280',
      yearlySubscription: '195',
      fundamentals: [
        '6 user login​​',
        'Up to 4 channels​',
        'Trending discussions (Up to 12 )​',
      ],
      includes: [
        'Geographical demographics analysis (applicable for e-commerce)​',
        'Competitor Intelligence​',
        'Custom Analysis ​',
        'Cluster analysis​​',
        'Sentinel hub (reporting)​​',
        'Unlimited access to past ​reports & analysis​',
      ],
    },
    {
      id: '3',
      planName: 'Elite​',
      planDesc: 'For Large enterprises​​',
      plancost: 'Custom Pricing​​',
      showSubscription: false,
      monthlySubscription: '280',
      yearlySubscription: '195',
      fundamentals: ['Up to 12 user login/s​​​', 'Customized channels​​'],
      includes: [
        'Customized queries​​',
        'Enterprise API integrations​​',
        'Alerts & notification​​',
        'Custom Analysis ​​',
        'Advanced correlation analysis​​',
        'Priority onboarding​',
      ],
    },
  ];
  return (
    <Wrapper>
      <Container>
        <TitleContainer>
          <TitleText>Find a plan that works for your business</TitleText>
        </TitleContainer>
        <CardListContainer>
          {planData?.map((data, index) => {
            return (
              <div key={index}>
                <PlanCard
                  index={index}
                  setPopupOpen={(data) => props?.setPopupOpen(data)}
                  highlighted={data?.planName === 'Scale' ? true : false}
                  planData={data}
                />
              </div>
            );
          })}
        </CardListContainer>
      </Container>
    </Wrapper>
  );
};

export default FindAPlanCards;
